import { useEffect, useState } from "react";
// import { useCallback } from "react";
import { connect } from "react-redux";
import { createContext, useContext, useReducer } from "react";
// import { wsConnect, wsDisconnect } from "./actions/wsActions";
import { updateItemFromWS } from "./actions/itemActions";
// import { action } from "../components/contextActionFactory";
// import { createWrapper } from "../components/logicalWrapperFactory";
// import { JSXProvider } from "../components/types";
// import { Wrapper } from "../components/types";
import React, { Component } from "react";
import {
  useConnectionCallback,
  useConnectionPauseHandler,
  useMessageCallback,
} from "./EventHandlers";

import { useSession } from "./WebsocketUtils";
import { websocketReducer, initialWsState } from "./WebsocketReducer";

import { useSelector } from "react-redux";

import useWebSocket, { ReadyState } from "react-use-websocket";
import configData from "./configData.json";

export const WebsocketContext = createContext({});

export function useWebsocketContext() {
  return useContext(WebsocketContext);
}

function WebsocketContextProvider({
  children,
  page,
  updateItemFromWS,
  wsConnect,
  wsDisconnect,
}) {
  const auth = useSelector((state) => state.auth);

  const [state, dispatch] = useReducer(websocketReducer, initialWsState);
  const onMessage = useMessageCallback(dispatch);

  // const [setConnectFn, onClose] = useConnectionPauseHandler(state, dispatch);
  // const onOpen = useConnectionCallback(dispatch);
  // const [connect, sendMessage, closeConn] = useSession(
  //   onOpen,
  //   onMessage,
  //   onClose,
  //   auth,
  //   state
  // );
  const websocketUrl = `${configData.WEBSOCKET_URL}`;

  const [socketUrl, setSocketUrl] = useState(null);
  const [messageHistory, setMessageHistory] = useState([]);
  const [lastAct, refreshAct] = useState(new Date());

  // const [websocketConnInitialized, initializeWebsocketConn] = useState(false);

  const { sendJsonMessage, sendMessage, lastMessage, readyState } =
    useWebSocket(socketUrl, {
      onOpen: () => {
        console.log("WEBSOCKET open", new Date());
        dispatch({ type: "CONNECTED", payload: {} });
        // wsConnect();
        // if (auth.token) {
        //   let payload = {
        //     action: "connectionValidation",
        //     msg: auth.token,
        //     // itemID: page.itemID
        //     //   ? page.itemID !== ""
        //     //     ? page.itemID
        //     //     : null
        //     //   : null,
        //   };

        //   sendJsonMessage(payload);
        // }
      },
      onClose: () => {
        // initializeWebsocketConn(false);
        console.log("WEBSOCKET close", new Date());
        dispatch({ type: "DISCONNECTED", payload: {} });
        // wsDisconnect();
      },
      onMessage: (resp) => {
        // console.log("WEBSOCKET receive message1", resp);
        if (resp.data) {
          let respTransl = JSON.parse(resp.data);
          if (respTransl.context) {
            console.log("WEBSOCKET receive message2");
            // if (respTransl.context === "UPDATE_ITEM") {
            //   updateItemFromWS(respTransl.data);
            // } else if (respTransl.context === "UPDATE_LOCK") {
            //   console.log("WEBSOCKET UPDATE LOC");
            //   updateItemFromWS(respTransl.data);
            // } else if (respTransl.context === "USER_ENTERS") {
            //   console.log("WEBSOCKET USER_ENTERS");
            //   updateItemFromWS(respTransl.data);
            // }
          }
        }
        onMessage(resp);
      },
      onError: (err) => {
        console.log("WEBSOCKET onError", err);
      },
      //Will attempt to reconnect on all close events, such as server shutting down
      shouldReconnect: (closeEvent) => true,
    });

  const connectionStatus = {
    [ReadyState.CONNECTING]: "Connecting",
    [ReadyState.OPEN]: "Open",
    [ReadyState.CLOSING]: "Closing",
    [ReadyState.CLOSED]: "Closed",
    [ReadyState.UNINSTANTIATED]: "Uninstantiated",
  }[readyState];

  // console.log("WEBSOCKET connectionStatus", connectionStatus);

  // useEffect(() => {

  //   setConnectFn(connect);
  // }, [setConnectFn, connect]);

  // wire everything
  // useEffect(() => {

  //   setConnectFn(connect);
  // }, [setConnectFn, connect]);

  // deliver the context to the application

  // const join = () => connect(auth);
  // const reconnect = () => {
  //   dispatch({
  //     type: "RECONNECTION_AFTER_RENDER",
  //     payload: {},
  //   });
  //   connect(auth);
  // };
  const close = () => {
    // const payload = {
    //   action: "DISCONNECT",
    // };
    // dispatch({ type: "GOING_AWAY" });
    // console.log("WEBSOCKET close", new Date());
    setSocketUrl(null);
    // sendJsonMessage(payload);
  };

  const connect = () => {
    // const payload = {
    //   action: "DISCONNECT",
    // };
    // dispatch({ type: "GOING_AWAY" });
    console.log("WEBSOCKET connect", new Date());
    // initializeWebsocketConn(true);
    setSocketUrl(websocketUrl); //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    // sendJsonMessage(payload);
  };

  const resetMessages = () => {
    dispatch({ type: "RESET_MESSAGES", payload: {} });
  };

  const refreshCon = () => {
    refreshAct(new Date());
  };

  const updateTaskDeleteUpdate = (projectID, itemID, lastPostId) => {
    // console.log("WEBSOCKET connect", new Date());
    dispatch({ type: "REMOVE_UPDATE_TASK", payload: { somthing: true } });
  };

  const refreshConnection = (checkLock, projectID, itemID) => {
    let payload = {
      action: "refreshConnection",
      checkLock: false,
    };

    // if (true) {
    //   // checklock !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    //   payload = {
    //     action: "refreshConnection",
    //     checkLock: true,
    //     projectID,
    //     itemID,
    //     token: auth.token,
    //   };
    // }

    // sendJsonMessage(payload);
  };

  // const checkLock = (projectID, itemID) => {
  //   const payload = {
  //     action: "checkLock",
  //     projectID,
  //     itemID,
  //     token: auth.token,
  //   };
  //   console.log("WEBSOCKET checkLock", payload);
  //   sendJsonMessage(payload);
  // };

  // const lockItem = (projectID, itemID, token) => {
  //   const payload = {
  //     action: "lockItem",
  //     itemID,
  //     projectID,
  //     token,
  //   };
  //   console.log("WEBSOCKET lockItem", projectID, itemID);
  //   sendJsonMessage(payload);
  //   console.log("socket send successful");
  //   // dispatch(updateChatLog(payload));
  // };

  const enterConference = (projectID, itemID) => {
    // const payload = {
    //   action: "enterConference",
    //   itemID,
    //   projectID,
    //   token: auth.token,
    // };
    // sendJsonMessage(payload);
    // console.log("socket send successful");
    // dispatch(updateChatLog(payload));
  };

  const mCurrentConnectedUsers = (currentConnectedUsers) => {
    dispatch({ type: "UPDATE_USER_ENTERS", payload: currentConnectedUsers });
  };

  const sendUpdateTask = (info) => {
    console.log("WEBSOCKET sendupdateTask", info);

    const payload = {
      action: "modifyTask",
      info,
      token: auth.token,
    };
    dispatch({
      type: "UPDATE_TASK_WS",
      payload: {
        info: {
          websocketMessageID: info.websocketMessageID,
        },
        messageReceived: true,
      },
    });
    // console.log("WEBSOCKET sendupdatetask", projectID, itemID, taskData);

    //FOR TEST PURPOSE !!!!!!!!!
    console.log("sendUpdateTask");
    sendJsonMessage(payload);
  };

  const setMessageReceived = ({ websocketMessageID }) => {
    dispatch({
      type: "MESSAGE_RECEIVED",
      payload: {
        websocketMessageID,
      },
    });
  };

  const updateItem = ({
    _id,
    task,
    taskChecked,
    map,
    charts,
    pc,
    headElem,
    dashboard,
    resource,
    kpi,
    changeLog,
    notification,
    toolParameters,
    projectID,
    resourcePlanning,
    note,
    lockWebsocket,
    unlock,
  }) => {
    const payload = {
      action: "modifyWSItem",
      token: auth.token,
      _id,
      projectID,
      task,
      taskChecked,
      // map,
      // charts,
      // pc,
      // headElem,
      // dashboard,
      // resource,
      // kpi,
      // changeLog,
      // resourcePlanning,
      // note,
      notification,
      lockWebsocket,
      unlock,

      // toolParameters,
      // ...info, is not working
    };
    // console.log("WEBSOCKET UPDATE ITEM", payload);
    // console.log("WEBSOCKET sendupdateitem", info);
    sendJsonMessage(payload);
  };

  // const updateItem = (info) => {
  //   const payload = {
  //     action: "modifyWSItem",
  //     projectID: info.projectID, //is not working
  //   };

  //   sendJsonMessage(payload);
  // };

  const heartbeat = () => {
    const payload = {
      action: "heartbeat",
    };
    // sendJsonMessage(payload);
    // dispatch(updateChatLog(payload));j
  };

  const sendChatMessage = (chatId, email, message) => {
    const payload = {
      chatId,
      email,
      message,
    };
    sendJsonMessage(payload);
  };

  // const unlockItem = (projectID, itemID, newUser) => {
  //   const payload = {
  //     action: "unlockItem",
  //     itemID,
  //     projectID,
  //     newUser,
  //   };
  //   sendJsonMessage(payload);
  //   // dispatch(updateChatLog(payload));j
  // };

  // const getAllLockedItems = (projectID) => {
  //   const payload = {
  //     action: "getAllLockedItems",
  //     projectID,
  //   };
  //   sendJsonMessage(payload);
  //   // dispatch(updateChatLog(payload));
  // };

  return (
    <WebsocketContext.Provider
      value={{
        ...state,
        ...connectionStatus,
        // join,
        // reconnect,
        // close,
        lastMessage,
        // lockItem,
        enterConference,
        close,
        // unlockItem,
        // getAllLockedItems,
        connect,
        heartbeat,
        updateItem,
        refreshConnection,
        // openModifyChat,
        updateTaskDeleteUpdate,
        sendChatMessage,
        sendUpdateTask,
        refreshCon,
        setMessageReceived,
        resetMessages,
        // checkLock,
        mCurrentConnectedUsers,
      }}
    >
      {children}
    </WebsocketContext.Provider>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  auth: state.auth,
  page: state.page,
});

export default connect(mapStateToProps, { updateItemFromWS })(
  WebsocketContextProvider
);
